import {Message} from '../../../_metronic/helpers'
import {getLeaveTypesById} from '../../../api/ConfigurationAPI'

import {APIResponse, InputErrorType, TableHeaderDataType} from '../../types/OtherTypes'
import {LeaveTypeInput} from '../../types/SettingModuleTypes'

export const validateForm = (formField: LeaveTypeInput) => {
  let cnt: number = 0
  const error: InputErrorType = {}
  let alphaRegex = /^[a-z][a-z .'-]*[a-z]*$/i
  let addressRegex = /^[a-zA-Z0-9][\w\W]*[a-zA-Z0-9)]+$/
  let addressInvalidCharacters = /[<>:"\\|?*\x00-\x1F~`!@#^+=;'[\]{}%_&$]/
  if (!formField.name.trim()) {
    cnt = cnt + 1
    error.name = 'Leave name is Required'
  } else {
    if (!alphaRegex.test(formField.name.trim())) {
      cnt = cnt + 1
      error.name =
        "Only letters (a-z,A-Z) and single space , . , ', - between two characters are allowed and last or first character of the Leave name must be letter (a-z,A-Z)"
    } else if (/(?=([^\w\d]))\1{2,}/g.test(formField.name.trim())) {
      cnt = cnt + 1
      error.name =
        "Only letters (a-z,A-Z) and single space , . , ' , - between two characters are allowed and last or first character of the Leave name must be letter (a-z,A-Z)"
    } else {
      if (formField.name.replaceAll(' ', '').length > 50) {
        cnt = cnt + 1
        error.name = 'Leave name should not be greater than 50 characters'
      }
    }
  }

  if (!formField.description) {
    cnt = cnt + 1
    error.description = 'Description is Required'
  }

  return {error, cnt}
}

export const getLeaveTypeTableHeaderData = (isActionColumnNeeded: boolean) => {
  const leaveTypeTableHeaderData: TableHeaderDataType[] = [
    {
      th: {
        id: 'donorName',
        style: {
          minWidth: '100px',
          width: '100px',
        },
      },
      text: 'Leave Type',
      isSortable: false,
    },
    {
      th: {
        id: 'bloodType',
        style: {
          minWidth: '150px',
          width: '150px',
        },
      },
      text: 'Description',
      isSortable: false,
    },

    {
      th: {
        id: 'actions',
        style: {
          width: '50px',
          minWidth: '50px',
        },
        hidden: isActionColumnNeeded,
      },
      text: 'Actions',
      justifyContent: 'end',
      isSortable: false,
    },
  ]
  return {leaveTypeTableHeaderData}
}

export const getLeaveTypeByID = (
  id: string,
  formField: LeaveTypeInput,
  setFormField: Function,
  setEditId: Function,
  setShowForm: Function,
  setInputError: Function
) => {
  getLeaveTypesById(id).then((res: APIResponse) => {
    if (res.statusCode === 200) {
      setFormField({
        ...formField,
        description: res?.data?.description,
        name: res?.data?.name ?? '',
      })
      setEditId(id)
      setInputError({})
      setShowForm(true)
    } else {
      Message(res.message, 'error')
    }
  })
}
